export const RESET_STATE = 'RESET_STATE';
export const SET_STORAGE_SPACE = 'SET_STORAGE_SPACE';
export const SET_SETUP_PASSWORD_STATUS = 'SET_SETUP_PASSWORD_STATUS';
export const SET_ARCHIVE_DELETION_STATUS = 'SET_ARCHIVE_DELETION_STATUS';
export const SET_CONTENT_ITEMS = 'SET_CONTENT_ITEMS';
export const SET_FETCH_STORAGE_SPACE_STATUS = 'SET_FETCH_STORAGE_SPACE_STATUS';
export const SET_FETCH_CONTENT_ITEMS_STATUS = 'SET_FETCH_CONTENT_ITEMS_STATUS';
export const SET_ACTIVE_CONTENT_TYPE = 'SET_ACTIVE_CONTENT_TYPE';
export const SET_APP_FEATURES = 'SET_APP_FEATURES';
export const SET_FILE_VERSIONS = 'SET_FILE_VERSIONS';
export const SET_FETCH_FILE_VERSIONS_STATUS = 'SET_FETCH_FILE_VERSIONS_STATUS';
export const SET_SIGN_FILE_LINK = 'SET_SIGN_FILE_LINK';
export const SET_SIGN_FILE_STATUS = 'SET_SIGN_FILE_STATUS';
export const SET_SEARCH_ENABLED_SATE = 'SET_SEARCH_ENABLED_SATE';
export const SET_SEARCH_RESULT_RECEIVED = 'SET_SEARCH_RESULT_RECEIVED';
export const SET_ACTIVE_VERSION_PATH = 'SET_ACTIVE_VERSION_PATH';
export const SET_ACTIVE_VOLUME_PATH = 'SET_ACTIVE_VOLUME_PATH';
export const SET_ACTIVE_FOLDER_ITEM = 'SET_ACTIVE_FOLDER_ITEM';
export const SET_FETCH_CONTAINER_ITEMS_STATUS = 'SET_FETCH_CONTAINER_ITEMS_STATUS';
export const SET_MACHINES = 'SET_MACHINES';
export const SET_BACKUPS = 'SET_BACKUPS';
export const SET_INCOMPLETE_BACKUPS = 'SET_INCOMPLETE_BACKUPS';
export const SET_INCOMPLETE_BACKUPS_COUNT = 'SET_INCOMPLETE_BACKUPS_COUNT';
export const SET_INCOMPLETE_BACKUPS_SIZE = 'SET_INCOMPLETE_BACKUPS_SIZE';
export const SET_TOTAL_USED_SPACE = 'SET_TOTAL_USED_SPACE';
export const SET_ACTIVE_MACHINE_ID = 'SET_ACTIVE_MACHINE_ID';
export const SET_ACTIVE_MACHINE_DISPLAY_NAME = 'SET_ACTIVE_MACHINE_DISPLAY_NAME';
export const SET_FETCH_BACKUPS_STATUS = 'SET_FETCH_BACKUPS_STATUS';
export const SET_ACTIVE_BACKUP_ID = 'SET_ACTIVE_BACKUP_ID';
export const SET_ACTIVE_BACKUP_DISPLAY_NAME = 'SET_ACTIVE_BACKUP_DISPLAY_NAME';
export const SET_DELETE_ALL_INCOMPLETE_STATUS = 'SET_DELETE_ALL_INCOMPLETE_STATUS';
export const SET_DISPLAY_USER_NAME = 'SET_DISPLAY_USER_NAME';
